import { get } from 'lodash';
import React, { useState } from 'react';

import { TableActionsEmbedModal } from './TableActionsButton/TableActionsEmbedModal';
import { ApplicationDescriptor, hasEmbeddedExecutionMethod } from './helpers/tableActionsHelper';
import { fetchTableActionsData } from './customHooks/useTableActionsResults';
import type { TableActionsConfigs } from './TableActionsButton/types';
import eventBus from './helpers/EventBus';
import { open } from 'common/window_location';

interface CustomLinkRendererProps {
  formattedValue: string;
  tableActionsContext?: TableActionsConfigs;
  selectedActionForExistingColumn: string;
}

export const CustomLinkRenderer = ({
  formattedValue,
  tableActionsContext,
  selectedActionForExistingColumn,
}: CustomLinkRendererProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedUrl, setSelectedUrl] = useState<string>('');

  const onModalDismiss = () => {
    setShowModal(false);
  };

  const onClick = async (event: React.MouseEvent) => {
    const target = event.target as HTMLElement;

    // Only trigger if the user clicks directly on the .link-value div
    if (target.className !== 'link-value') {
      return;
    }

    try {
      eventBus.dispatch('VISUALIZATION_LOADING', true);
      const response = await fetchTableActionsData({
        contextParams: tableActionsContext ?? {},
      });
      const applicationDescriptors = get(response, '0.applicationDescriptors', []);
      const matchedDescriptor = applicationDescriptors.find(
        (descriptor: ApplicationDescriptor) => descriptor.id === selectedActionForExistingColumn,
      );

      if (hasEmbeddedExecutionMethod(matchedDescriptor)) {
        setSelectedUrl(matchedDescriptor?.url);
        setShowModal(true);
      } else {
        open(matchedDescriptor?.url, '_blank');
      }

      eventBus.dispatch('VISUALIZATION_LOADING', false);
    } catch (error) {
      console.error('Error fetching Table Actions data:', error);
      eventBus.dispatch('VISUALIZATION_LOADING', false);
    }
  };

  return (
    <div className="link-value" onClick={onClick}>
      {formattedValue}
      {showModal && (
        <TableActionsEmbedModal url={selectedUrl} onDismiss={onModalDismiss} showModal={showModal} />
      )}
    </div>
  );
};
